var websiteData = require('diy/util/websiteData');

diy.angular.registerConstant('diywebsiteid',
    websiteData.getId()
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/services/diywebsiteid.js
 ** module id = 882
 ** module chunks = 0
 **/